import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#0065bd", // blue
        secondary: "#005293", // dark blue
        tertiary: "#64a0c8", // light blue
        accent: "#eeeeee", // gray
        alert: "#E47B73", // red
        attention: "#E99A27", // orange
        success: "#459086" // green
      },
    },
  },
  options: {
    customProperties: true
  },
};

export default new Vuetify(opts);